import * as React from 'react';
import cx from 'classnames';

import './styles/Container.scss';

export type ContainerAlign = 'left' | 'center' | 'right';
export type ContainerSize = 'large' | 'xmedium' | 'medium' | 'small' | 'xsmall' | 'xxsmall';

export type Props = {
  align?: ContainerAlign;
  children: React.ReactNode;
  className?: string;
  flush?: boolean;
  /** Unrestricted `width` */
  full?: boolean;
  size?: ContainerSize;
  inline?: boolean;
};

type DefaultProps = {
  align: ContainerAlign;
};

export default class Container extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    align: 'center',
  };

  render() {
    const { align, children, className, flush, full, size, inline } = this.props;

    return (
      <div
        className={cx(
          'Container',
          align && `Container--${align}`,
          flush && 'Container--flush',
          full && 'Container--full',
          size && `Container--${size}`,
          inline && `Container--inline`,
          className
        )}>
        {children}
      </div>
    );
  }
}
